import BaseModal from "../common/HPBaseModal";
import { ModalProps } from "@_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";
import { t } from "@utils/i18n";
import React from "react";

interface PublishDashboardModalProps extends ModalProps {
  isRefreshing: boolean;
  action: () => void;
  tabsCount: number;
}

const PublishDashboardModal: React.FC<PublishDashboardModalProps> = ({
  isRefreshing,
  action,
  tabsCount,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  return (
    <BaseModal
      loading={isRefreshing}
      title={t("modals.publishDashboard.title")}
      message={t("modals.publishDashboard.message", { count: tabsCount })}
      onConfirm={action}
      onCancel={closeTopModal}
      confirmButtonText={t("modals.publishDashboard.confirmButton")}
      cancelButtonText={t("common.cancel")}
    />
  );
};

export default PublishDashboardModal;
